import React from "react";
import {
  qhseBg,
  supplyResato1,
  supplyResato2,
  supplyResato3,
  supplyResato4,
  supplyResato5,
  supplyResato6,
  supplyResato7,
  supplyResatoPrez1,
  supplyResatoPrez2,
  supplyResatoPrez3,
  supplyResatoPrez4,
  supplyResatoPrez5,
} from "../../../../assets/images";
import { useTranslation } from "react-i18next";
import SubOtherHero from "../../../../Components/Breadcrumb/SubOtherHero/SubOtherHero";

const Hydro = () => {
  const { t } = useTranslation();

  return (
    <>
      <div
        className="bg-black/60"
        style={{
          position: "relative",
          overflow: "hidden",
          backgroundImage: `url(${qhseBg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          width: "100%",
          height: window.innerWidth < 640 ? "200px" : "300px",
        }}
      >
        <SubOtherHero title="Pressure testing: Hydrostatic pressure testing" />
      </div>

      <div className="bg-[#EDEDED] py-10 md:py-20">
        <div className="max-w-containerSm md:max-w-container mx-auto ">
          {/* Main Text */}
          <p className="text-[22px] md:text-[44px] font-bold text-[#141615] font-firstFont">
            {t("Pressure testing: Hydrostatic pressure testing")}
          </p>
          {/* HPU */}
          <div className="md:flex md:items-start md:justify-between gap-10 flex-col md:flex-row mt-10">
            <div className="md:w-1/2">
              <p className="mt-6 text-[20px] font-semibold text-[#141615]">
                {t(
                  "Pressure testing: Hydrostatic pressure testing HPU-sep: Separated test control system"
                )}
              </p>

              <p className="mt-5 text-[14px] md:text-[20px] text-[#41444B]">
                {t(
                  "A HPU separate (HPU-sep) can give you maximum safety during the process of testing objects. The HPU is a separated workshop test control system that is available in different configurations. Which gives you the opportunity to find the HPU system that fits your specific test requirements. With the HPU-sep you can create a test bay setting. The high-pressure test system and the test object are positioned in the test bay and the HPU-sep control panel is placed in a separate control room. This results in a fully separated setup with no high-pressure components outside of the test bay, which offers you safe test circumstances."
                )}
              </p>

              <a
                href={`${supplyResatoPrez1}`}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block bg-[#B31F11] text-white py-2 px-4 rounded-md transition-colors mt-5"
              >
                {t("To learn more information please download datasheet")}
              </a>
            </div>

            {/* Right Image */}
            <div className="md:w-1/2 gap-4 mt-8 md:mt-0">
              <img
                src={supplyResato1}
                alt="Drill Bit 1"
                className="w-full rounded-lg shadow-md"
              />
            </div>
          </div>
          {/* BMS */}
          <div className="md:flex md:items-start md:justify-between gap-10 flex-col md:flex-row mt-10">
            <div className="md:w-1/2">
              <p className="mt-6 text-[20px] font-semibold text-[#141615]">
                {t("BMS: High flow high pressure pump")}
              </p>

              <p className="mt-5 text-[14px] md:text-[20px] text-[#41444B]">
                {t("Outlet pressure range: 4,200 bar (60,000 psi)")}
              </p>
              <p className="mt-5 text-[14px] md:text-[20px] text-[#41444B]">
                {t(
                  "The BMS mobile pump system enables the testing of objects at different locations in a workshop or at field locations. The wheels or forklift pockets make the BMS much easier to move in comparison to standard workshop units. This high flow / high pressure system enables adequate testing and adapts ideally to your specific requirements for testing large volumes of objects at high pressure. The BMS is generally equipped with two air driven pumps, thus accelerating your operational process. To test objects even quicker, the standard high flow high pressure pump integrated into the BMS can be expanded with a high flow low pressure air driven pump. Additionally, BMS can be equipped even more than two air driven pumps based on your requirements."
                )}
              </p>

              <a
                href={`${supplyResatoPrez2}`}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block bg-[#B31F11] text-white py-2 px-4 rounded-md transition-colors mt-5"
              >
                {t("To learn more information please download datasheet")}
              </a>
            </div>

            {/* Right Image */}
            <div className="md:w-1/2 grid md:grid-cols-2 gap-4 mt-8 md:mt-0">
              <img
                src={supplyResato2}
                alt="Drill Bit 1"
                className="w-full rounded-lg shadow-md"
              />
              <img
                src={supplyResato3}
                alt="Drill Bit 1"
                className="w-full rounded-lg shadow-md"
              />
              <img
                src={supplyResato4}
                alt="Drill Bit 1"
                className="w-full rounded-lg shadow-md"
              />
            </div>
          </div>
          {/* RPS */}
          <div className="md:flex md:items-start md:justify-between gap-10 flex-col md:flex-row  mt-10">
            <div className="md:w-1/2">
              <p className="mt-6 text-[20px] font-semibold text-[#141615]">
                {t("RPS: High pressure power pack")}
              </p>

              <p className="mt-5 text-[14px] md:text-[20px] text-[#41444B]">
                {t("Outlet pressure range: Up to 4,200 bar (60,000 psi)")}
              </p>
              <p className="mt-5 text-[14px] md:text-[20px] text-[#41444B]">
                {t("Flexibility: Portable and easy to move")}
              </p>
              <p className="mt-5 text-[14px] md:text-[20px] text-[#41444B]">
                {t(
                  "Mediums: Suitable for pressurizing oil, water or other fluids"
                )}
              </p>
              <p className="mt-5 text-[14px] md:text-[20px] text-[#41444B]">
                {t(
                  "Portable power pack type RPS is a self-contained air-driven system of proven design. Not only can it be used to pressurize valves, fittings, hoses, piping, vessels and wellhead equipment, but it is also suitable for supply of hydraulic power to operate cylinders, presses, rams, jacks, bolt tensioners and actuators. Water, oil or an emulsion of both can be used as the high-pressure medium. Other applications such as chemical injection can be carried out as the system is suitable for a wide range of chemicals."
                )}
              </p>

              <a
                href={`${supplyResatoPrez3}`}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block bg-[#B31F11] text-white py-2 px-4 rounded-md transition-colors mt-5"
              >
                {t("To learn more information please download datasheet")}
              </a>
            </div>

            {/* Right Image */}
            <div className="md:w-1/2 gap-4 mt-8 md:mt-0">
              <img
                src={supplyResato5}
                alt="Drill Bit 1"
                className="w-full rounded-lg shadow-md"
              />
            </div>
          </div>
          {/* MPS */}
          <div className="md:flex md:items-start md:justify-between gap-10 flex-col md:flex-row mt-10">
            <div className="md:w-1/2">
              <p className="mt-6 text-[20px] font-semibold text-[#141615]">
                {t("MPS: Portable mini pump")}
              </p>

              <p className="mt-5 text-[14px] md:text-[20px] text-[#41444B]">
                {t("Outlet pressure range: Up to 2,500 bar (36,250 psi)")}
              </p>
              <p className="mt-5 text-[14px] md:text-[20px] text-[#41444B]">
                {t("Operation: All operating features panel mounted")}
              </p>
              <p className="mt-5 text-[14px] md:text-[20px] text-[#41444B]">
                {t(
                  "Mediums: Suitable for pressurizing oil, water or other fluids"
                )}
              </p>
              <p className="mt-5 text-[14px] md:text-[20px] text-[#41444B]">
                {t(
                  "The MPS is a handy portable air driven mini pump that can be easily carried because of its weight (less than 17 kg with a filled tank) and size (405 x 308 x 365 mm). Although this mini pump is small in size and low in weight, it is very suitable for the pressure testing of objects for pressure ranges up to 1,800 bar at 7 bar air-drive pressure and 2,500 bar at 10 bar air drive pressure. Through its pressure supply capacity, it is possible to manually drive the pump with a detachable hand lever if you are in a situation when air pressure is not available. The medium for pressurizing objects with this test system can be a fluid such as water or oil."
                )}
              </p>

              <a
                href={`${supplyResatoPrez4}`}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block bg-[#B31F11] text-white py-2 px-4 rounded-md transition-colors mt-5"
              >
                {t("To learn more information please download datasheet")}
              </a>
            </div>

            {/* Right Image */}
            <div className="md:w-1/2 gap-4 mt-8 md:mt-0">
              <img
                src={supplyResato6}
                alt="Drill Bit 1"
                className="w-full rounded-lg shadow-md"
              />
            </div>
          </div>
          {/* HPU-CC */}
          <div className="md:flex md:items-start md:justify-between gap-10 flex-col md:flex-row mt-10">
            <div className="md:w-1/2">
              <p className="mt-6 text-[20px] font-semibold text-[#141615]">
                {t("HPU-CC: High pressure pump system")}
              </p>

              <p className="mt-5 text-[14px] md:text-[20px] text-[#41444B]">
                {t("Outlet pressure range: Up to 7,000 bar (101,500 psi)")}
              </p>
              <p className="mt-5 text-[14px] md:text-[20px] text-[#41444B]">
                {t("Capacity range: Up to 50 liters per minute")}
              </p>
              <p className="mt-5 text-[14px] md:text-[20px] text-[#41444B]">
                {t("Operation: Computer-controlled")}
              </p>
              <p className="mt-5 text-[14px] md:text-[20px] text-[#41444B]">
                {t(
                  "The HPU-CC Series is a fully-automated high pressure test system for workshop owners who perform many testing activities and require quality certification and traceability. The system can be used for pressure testing on valves, relief valves, safety valves, hoses, completions, well head components, and for hydroforming and filling applications. To reduce operator error, the software allows for user-management and test recipe creation. The execution of tests requires less time as the objects need be connected and the test procedure is started with a push of a button. A certificate can be exported into other software using APIs or exported by PDF. The reliability of the system is established by selecting components that harmonize together and create performance that lasts. Our systems include engineered pumps, intensifiers, valves and fittings, and more from Resato. The performance of the HPU-CC Series can be enhanced using a multi-pump or intensifier set-up that reduces pressure build-up time and improves reliability. The HPU-CC Series can be tailored to your specific high pressure application. Please contact our experts for more information."
                )}
              </p>
              <p className="mt-6 text-[20px] font-semibold text-[#141615]">
                {t("Benefits & Features")}
              </p>
              <ul className="mt-4 text-[14px] md:text-[20px] text-[#41444B] list-disc list-inside space-y-3">
                <li>
                  {t(
                    "Fully automatic test cycle performance that saves testing and setup time"
                  )}
                </li>
                <li>
                  {t(
                    "Ergonomic, safe and user-friendly design allows for healthy use and quick training"
                  )}
                </li>
                <li>{t("Low noise level")}</li>
                <li>
                  {t("Suitable for various test mediums, due to Resato pumps")}
                </li>
                <li>
                  {t(
                    "Flexibility in scaling production through modular setup of the system and software for testing procedures"
                  )}
                </li>
                <li>
                  {t(
                    "Integration in customer processes with product options and software APIs"
                  )}
                </li>
                <li>{t("Bespoke setup (hardware and software)")}</li>
                <li>
                  {t(
                    "All parts made of non-corrosive materials to prevent corrosion in the system"
                  )}
                </li>
                <li>
                  {t(
                    "Easy and low-cost maintenance through knowledge base access and product design"
                  )}
                </li>
                <li>
                  {t(
                    "Proven reliability due to selected components that harmonize together"
                  )}
                </li>
              </ul>
              <p className="mt-6 text-[20px] font-semibold text-[#141615]">
                {t("Application Areas")}
              </p>
              <ul className="mt-4 text-[14px] md:text-[20px] text-[#41444B] list-disc list-inside space-y-3">
                <li>{t("Hose testing")}</li>
                <li>{t("Oil & Gas industry")}</li>
                <li>{t("Hydrostatic testing")}</li>
                <li>{t("Leak testing")}</li>
                <li>{t("Hydroforming")}</li>
                <li>{t("Automotive testing")}</li>
                <li>{t("Autofrettage")}</li>
                <li>{t("Food preservation research")}</li>
                <li>{t("Hydraulic testing")}</li>
                <li>{t("Controlling")}</li>
              </ul>
              <p className="mt-6 text-[20px] font-semibold text-[#141615]">
                {t("Options")}
              </p>
              <ul className="mt-4 text-[14px] md:text-[20px] text-[#41444B] list-disc list-inside space-y-3">
                <li>{t("Pre-fill systems")}</li>
                <li>
                  {t("Combination system with high pressure gas test systems")}
                </li>
                <li>{t("Safety systems")}</li>
                <li>{t("Built-in tank(s)")}</li>
                <li>{t("Test enclosures")}</li>
              </ul>

              <a
                href={`${supplyResatoPrez5}`}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block bg-[#B31F11] text-white py-2 px-4 rounded-md transition-colors mt-5"
              >
                {t("To learn more information please download datasheet")}
              </a>
            </div>

            {/* Right Image */}
            <div className="md:w-1/2 gap-4 mt-8 md:mt-0">
              <img
                src={supplyResato7}
                alt="Drill Bit 1"
                className="w-full rounded-lg shadow-md"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Hydro;
